<template>
  <div>
    <DemoForm />
  </div>
</template>
<script>
import DemoForm from "../pages/Demo/DemoForm.vue";
export default {
  components: {
    DemoForm,
  },
};
</script>
